<div>

  <!-- Header -->
  <header>
    <shared-pg-global-header *ngIf="shouldShowSharedGlobalHeader"></shared-pg-global-header>
    <app-global-header 
      (logoutClicked)="onLogoutClicked()" 
      [menuLoading]="menuLoading" 
      [isUserLoggedIn]="isUserLoggedIn" 
      [isFederationLoaded]="isFederationLoaded" 
      [userEmail]="user" 
      [hideLogout]="shouldShowSharedGlobalHeader"
    ></app-global-header>
  </header>

  <ng-container *ngIf="hospitalLoadError">
    <div style="margin-left: 400px; color: red; font-weight: bold; font-size: medium;">
      Error loading facility data. Please use the menu to try again.
    </div>
  </ng-container>

</div>

<div class="contentcontainer">

  <div class="tp-wrap" id="app-wrapper">
    <div class="tp-vh" id="nav-wrapper">
      <style>
        #nav-spinner {
          margin: 0 auto;
          text-align: center;
          position: absolute;
          width: 100%;
          height: 100vh;
          display: none;
          z-index: 10;
        }

        #nav-spinner.load-true {
          display: inline-block;
        }

        .ndnqi-spinner {
          color: #00253B;
          position: relative;
          width: 64px;
          height: 64px;
          top: 20%;
          left: 6%;
        }

        .ndnqi-spinner div {
          transform-origin: 32px 32px;
          animation: ndnqi-spinner 1.2s linear infinite;
        }

        .ndnqi-spinner div:after {
          content: " ";
          display: block;
          position: absolute;
          top: 3px;
          left: 29px;
          width: 5px;
          height: 14px;
          border-radius: 20%;
          background: #00253B;
        }

        .ndnqi-spinner div:nth-child(1) {
          transform: rotate(0deg);
          animation-delay: -1.1s;
        }

        .ndnqi-spinner div:nth-child(2) {
          transform: rotate(30deg);
          animation-delay: -1s;
        }

        .ndnqi-spinner div:nth-child(3) {
          transform: rotate(60deg);
          animation-delay: -0.9s;
        }

        .ndnqi-spinner div:nth-child(4) {
          transform: rotate(90deg);
          animation-delay: -0.8s;
        }

        .ndnqi-spinner div:nth-child(5) {
          transform: rotate(120deg);
          animation-delay: -0.7s;
        }

        .ndnqi-spinner div:nth-child(6) {
          transform: rotate(150deg);
          animation-delay: -0.6s;
        }

        .ndnqi-spinner div:nth-child(7) {
          transform: rotate(180deg);
          animation-delay: -0.5s;
        }

        .ndnqi-spinner div:nth-child(8) {
          transform: rotate(210deg);
          animation-delay: -0.4s;
        }

        .ndnqi-spinner div:nth-child(9) {
          transform: rotate(240deg);
          animation-delay: -0.3s;
        }

        .ndnqi-spinner div:nth-child(10) {
          transform: rotate(270deg);
          animation-delay: -0.2s;
        }

        .ndnqi-spinner div:nth-child(11) {
          transform: rotate(300deg);
          animation-delay: -0.1s;
        }

        .ndnqi-spinner div:nth-child(12) {
          transform: rotate(330deg);
          animation-delay: 0s;
        }

        @keyframes ndnqi-spinner {
          0% {
            opacity: 1;
          }

          100% {
            opacity: 0;
          }
        }

        .blocker {
          width: 100%;
          height: 100vh;
          position: absolute;
          left: 3em;
          top: 0;
          cursor: default;
          padding-left: 30px;
        }
      </style>

      <div class="loading-spinner load-{{menuLoading}}" id="nav-spinner">
        <a href="#" onclick="return false;" class="blocker">
          <div class="ndnqi-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </a>
      </div>

      <ng-container *ngIf="subscriptionChangeError">
        <div class="error-message">
          Error changing Subscription
        </div>
      </ng-container>

      <p-slideMenu #slidemenu [viewportHeight]="500" [menuWidth]="250" [ngClass]="{'slide-menu-animating': menuAnimating}"></p-slideMenu>

    </div> <!-- close nav-wrapper div -->

    <p-confirmDialog key="timeoutConfirmation" [baseZIndex]="450000"></p-confirmDialog>

    <div *ngIf="menuLoadError">
      Error Loading Menu
    </div>

    <div class="tp-vh tp-nb tp-mw" id="app-content">

      <!-- IFrame for Portal -->
      <iframe id="appPortalIframe" class="legacy" [ngClass]="portalClass"
              title="Portal Frame"
              [src]="portalFrameProp.src"
              [hidden]="!portalFrameProp.visibility"
              (load)="portalIframeLoaded()"
              scrolling="no"></iframe>

      <!-- IFrame for Indicator Factory -->
      <iframe id="appIndicatorIframe"
              title="Indicator Factory Client Frame"
              [src]="indicatorFrameProp.src"
              [hidden]="!indicatorFrameProp.visibility"
              (load)="indicatorIframeLoaded()"
              scrolling="no"></iframe>

      <!-- IFrame for Validation Engine Client -->
      <iframe id="appValidationIFrame"
              class="legacy"
              title="Validation Client Frame"
              [src]="validationFrameProp.src"
              [hidden]="!validationFrameProp.visibility"
              (load)="validationIframeLoaded()"
              scrolling="no"></iframe>

      <!-- IFrame for Performance Reports -->
      <iframe id="appPerformanceIFrame"
              class="legacy"
              title="Performance Reports Client Frame"
              [src]="performanceFrameProp.src"
              [hidden]="!performanceFrameProp.visibility"
              (load)="performanceIframeLoaded()"
              scrolling="no"></iframe>

      <!-- IFrame for System Management -->
      <iframe id="appSystemManagementIFrame"
              class="legacy"
              title="System Management Client Frame"
              [src]="sysMngFrameProp.src"
              [hidden]="!sysMngFrameProp.visibility"
              (load)="sysMngIframeLoaded()"
              scrolling="no"></iframe>

      <!-- IFrame for Ndnqi Foundation: Unit Management -->
      <iframe id="appNdnqiFoundationIFrame"
              class="legacy"
              title="NDNQI Foundation Client Frame"
              [src]="ndnqiFoundationFrameProp.src"
              [hidden]="!ndnqiFoundationFrameProp.visibility"
              (load)="ndnqiFoundationIframeLoaded()"
              scrolling="no"></iframe>

      <!-- IFrame for Public Reports -->
      <iframe id="appNdnqiPublicReportsIFrame"
              class="legacy"
              title="Public Reports Client Frame"
              [src]="ndnqiPublicReportsFrameProp.src"
              [hidden]="!ndnqiPublicReportsFrameProp.visibility"
              (load)="ndnqiPublicReportsIframeLoaded()"
              scrolling="no"></iframe>

      <!-- IFrame for Learning Management -->
      <iframe *ngIf="isDevOrLocalEnv" id="appLearningManagementIFrame"
              class="legacy"
              title="Learning Management Client Frame"
              [src]="learningMngFrameProp.src"
              [hidden]="!learningMngFrameProp.visibility"
              (load)="learningMngIframeLoaded()"
              scrolling="no"></iframe>

      <div *ngIf="demographicContent" class="fixed-modal">
        <app-demographic-modal [hospitalName]="demographicContent"></app-demographic-modal>
      </div>

      <router-outlet #outlet="outlet"></router-outlet>

    </div><!-- close app-content div -->
  </div><!-- close app-wrapper div -->
</div>

<ng-container *ngIf="timeoutCounterDisplayEnabled; else noTimeoutTemplate">
  <shared-pg-footer2 [applicationVersion]="applicationVersion" [swAppVersion]="swAppVersion" [timeoutRemaining]="timeoutCounter"></shared-pg-footer2>
</ng-container>

<ng-template #noTimeoutTemplate>
  <shared-pg-footer2 [applicationVersion]="applicationVersion" [swAppVersion]="swAppVersion"></shared-pg-footer2>
</ng-template>
